import {
  Box,
  SkeletonGroup,
  SkeletonLine,
  SkeletonRectangle,
} from '@wix/design-system';

import css from './index.module.scss';

export type SkeletonLoadingProps = {
  isMobile: boolean;
};

export const SkeletonLoading = ({ isMobile }: SkeletonLoadingProps) => (
  isMobile ? <SkeletonLoadingMobile /> : <SkeletonGroup>
    <Box direction="vertical" gap="20px">
      <SkeletonRectangle className={css.header} />
      <Box direction="vertical" gap="3" className={css.searchResults}>
        {[...Array(3)].map((_, index) => (
          <Box direction="vertical" key={index} gap="4">
            <Box direction="vertical">
              <Box>
                <SkeletonRectangle className={css.articleTag} />
              </Box>
              <Box direction="vertical" gap="13px">
                <Box direction="vertical" gap="2">
                  <SkeletonLine className={css.articleTitle} />
                </Box>
                <Box verticalAlign="middle">
                  <Box direction="vertical" gap="2" width="100%">
                    <Box verticalAlign="middle" gap="7">
                      <Box direction="vertical" gap="2" width="100%">
                        <SkeletonLine className={css.descriptionFirst} />
                        <SkeletonLine className={css.descriptionSecond} />
                      </Box>
                      <Box>
                        <SkeletonRectangle className={css.timeToRead} />
                      </Box>
                    </Box>
                    <Box verticalAlign="middle" gap="11px">
                      <SkeletonRectangle className={css.category} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            {index < 2 && <SkeletonRectangle className={css.separator} />}
          </Box>
        ))}
      </Box>
    </Box>
  </SkeletonGroup>
);

export const SkeletonLoadingMobile = () => (
  <SkeletonGroup>
    <Box className={css.skeletonLoadingMobileWrapper} direction="vertical">
      <SkeletonRectangle className={css.header} />
      <Box direction="vertical" gap="3" className={css.searchResultsMobile}>
        {[...Array(3)].map((_, index) => (
          <Box direction="vertical" key={index} gap="4">
            <Box className={css.skeletonLoadingMobileItem} direction="vertical">
              <Box>
                <SkeletonRectangle className={css.articleTag} />
              </Box>
              <Box direction="vertical" gap="13px">
                <Box direction="vertical" gap="1">
                  <SkeletonLine className={css.articleTitle} />
                  <SkeletonLine className={`${css.articleTitle} ${css.shortTitle}`} />
                </Box>
                <Box verticalAlign="middle">
                  <Box direction="vertical" gap="2" width="100%">
                    <Box verticalAlign="middle" gap="2" direction="vertical">
                      <Box direction="vertical" gap="8px" width="100%">
                        <SkeletonLine className={css.descriptionFirst} />
                        <SkeletonLine className={css.descriptionSecond} />
                      </Box>
                      <Box gap="10px" className={css.bottomRow}>
                        <SkeletonRectangle className={css.category} />
                        <SkeletonRectangle className={css.timeToRead} />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            {index < 2 && <SkeletonRectangle className={css.separator} />}
          </Box>
        ))}
      </Box>
    </Box>
  </SkeletonGroup>
);
